<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="奖项名称">
              <a-input
                placeholder="请输入奖项名称"
                v-model="queryParam.honorName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="奖项类型">
              <a-select
                v-model="queryParam.honorType"
                placeholder="请选择奖项类型"
              >
                <a-select-option :value="1">历史沿革</a-select-option>
                <a-select-option :value="2">历史荣誉</a-select-option>
                <!-- <a-select-option
                  v-for="(item, index) in typeAllList"
                  :key="index"
                >
                  {{ item.title }}
                </a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="获奖年份">
              <a-date-picker
                v-model="queryParam.honorYear"
                placeholder="请选择奖励年份"
                format="YYYY"
                :mode="year"
                :open="open"
                @openChange="openChange"
                @change="clearTime"
                @panelChange="panelChange"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="4" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >

              <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!-- <a-button
        @click="handleAdds"
        style="margin-left: 8px"
        type="primary"
        icon="plus"
        >导出</a-button
      > -->
      <!-- 高级查询区域 -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>
    <!-- 清空 -->
    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
      <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
      <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
      >项
      <a style="margin-left: 24px" @click="onClearSelected">清空</a>
    </div>
    <!-- 导入 -->

    <a-table
      ref="table"
      size="middle"
      :scroll="{ x: true }"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="honorYear" slot-scope="text, record">
        {{ record.honorYear }}-{{
          record.honorMonth > 10 ? record.honorMonth : '0' + record.honorMonth
        }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handlDelete(record.id)">删除</a>
      </span>
    </a-table>

    <companyHonorModal ref="modalForm" @ok="modalFormOk"></companyHonorModal>
  </a-card>
</template>

<script>
import { ajaxGetDictItems } from '@/api/api';

import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import companyHonorModal from './companyHonorModal.vue';
import { filterObj } from '@/utils/util';
import { uploadAction, postAction, getAction, downFile } from '@/api/manage';
import moment from 'moment';
export default {
  name: 'ProductsQuotationList',
  components: {
    JDate,
    companyHonorModal
  },
  data() {
    return {
      description: '产品报价管理页面',
      fileList: [],
      year: 'year',
      open: false,
      showDialog: false,
      showLead: false,
      uploading: false,
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      loading: false,
      queryParam: {
        honorName: '',
        honorType: undefined,
        honorYear: ''
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '奖项名称',
          align: 'center',
          dataIndex: 'honorName'
        },
        {
          title: '奖项类型',
          align: 'center',
          sorter: true,
          dataIndex: 'honorType_dictText'
        },

        {
          title: '获奖时间',
          align: 'center',
          dataIndex: 'honorYear',
          scopedSlots: { customRender: 'honorYear' }
        },
        {
          title: '来源',
          align: 'center',
          dataIndex: 'honorFrom',
          customRender: text => {
            return !text || text == '' ? '--' : text;
          }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/honer/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/honer/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/honer/deleteBatch',
        exportXlsUrl: process.env.VUE_APP_CMS_PRODUCT + '/front/api/exportXls' //导出
      },
      dictOptions: {},
      superFieldList: [],
      typeAllList: []
    };
  },
  created() {
    this.getList();
    this.getTypeList();
  },
  computed: {},
  methods: {
    //获取分类
    getTypeList() {
      let code = 'cm_ct_honer';
      ajaxGetDictItems(code, null).then(res => {
        if (res.success) {
          this.typeAllList = res.result;
        }
      });
    },
    initDictConfig() {},
    channel() {
      this.showDialog = true;
    },
    //删除
    handlDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          getAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },

    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      console.log(params);
      getAction(that.url.list, params)
        .then(res => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加

    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdds() {
      let params = {
        fundCode: '001122'
      };
      downFile(this.url.exportXlsUrl, params).then(res => {});
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      if (record.honorYear) {
        record.honorYear = moment(record.honorYear, 'YYYY');
      }
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    //弹出日历和关闭日历的回调
    openChange(status) {
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    //日期面板变化时的回调
    panelChange(value) {
      let val = String(value.year());
      this.queryParam.honorYear = val;
      this.open = false;
      console.log(val);
    },
    clearTime() {}
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style scoped lang="less">
.table-operator {
  margin-bottom: 8px;
  .ant-btn {
    margin: 0 8px 8px 0;
  }
}
</style>
